// export const BASE_URL = 'http://localhost:3021';
export const BASE_URL = 'https://teraquiz.com';

export const VALIDATE_PAYMENT = '/paymentasaas/payment/validate/';
export const CREATE_ORDER = '/paymentasaas/payment/card';
export const CREATE_ORDER_PIX = '/paymentasaas/payment/pix';
export const GET_CHECKOUT_BY_ID = '/paymentasaas/get/checkout/by/id';
export const APPLY_CUPOM = '/paymentasaas/cupons/aplicar';

